import { render, staticRenderFns } from "./EModalPlanoBimestralPDF.vue?vue&type=template&id=faa0b7a8"
import script from "./EModalPlanoBimestralPDF.vue?vue&type=script&lang=js"
export * from "./EModalPlanoBimestralPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports